import { render, staticRenderFns } from "./NewFeature.vue?vue&type=template&id=562f8fee&scoped=true"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"
import style0 from "./NewFeature.vue?vue&type=style&index=0&id=562f8fee&prod&lang=scss&scoped=true"
import style1 from "./NewFeature.vue?vue&type=style&index=1&id=562f8fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f8fee",
  null
  
)

export default component.exports